import React, { FC } from "react";
import Image from "next/image";

interface GenerateLinksHeaderProps {
    pageTitle?: string;
    mainTitle?: string;
    description?: string;
    imageUrl?: string;
    buttonText?: string;
    noSection?: boolean;
    scrollHandler?: () => void;
}

const GenerateLinksHeader: FC<GenerateLinksHeaderProps> = ({
    pageTitle = "WhatsApp Link Generator",
    mainTitle = "Connect with Your Customers Instantly Using WhatsApp Links",
    description = "Boost your sales and build meaningful connections using Gallabox's WhatsApp Link Generator. Increase customer satisfaction and improve business impact by giving your customers a direct line to reach you!",
    imageUrl = "https://assets.gallabox.com/gb-home/whatsapp-link-gen/header-new.png",
    buttonText = " Generate Links Now",
    noSection = false,
    scrollHandler,
}) => {
    const handleButtonClick = () => {
        if (scrollHandler) {
            scrollHandler();
        }
    };

    return (
        <header className="max-w-6xl mx-auto px-4 lg:px-0 pt-4  bg-white ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between lg:py-20 pt-0">
                <div className="lg:w-6/12 w-full flex flex-col pt-10">
                    <div
                        className="text-green-700 bg-green-100 wati-top-green justify-center items-center lg:text-base font-bold flex flex-nowrap w-fit m-auto md:m-0"
                        style={{ padding: "1px 12px", borderRadius: "50px", border: "0.5px solid rgb(9, 146, 80)" }}
                    >
                        <h5 className="lg:text-base text-xs pr-1">{pageTitle}</h5>
                        <span className=" w-5 h-5">
                            <Image
                                alt="white-border"
                                height={18}
                                loading="lazy"
                                width={18}
                                src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                className="ml-2"
                            />
                        </span>
                    </div>
                    <h1 className="flex flex-col lg:justify-start justify-center text-gray-600 lg:pt-4">
                        <span className="lg:text-4xl lg:font-bold text-3xl text-gray-600 text-center md:text-left mt-5">{mainTitle}</span>
                    </h1>
                    <p className="lg:py-6 py-4 lg:text-l font-normal text-center lg:text-left lg:text-gray-700 text-gray-600">{description}</p>
                    <div className="flex flex-col pt-4 lg:pt-0 md:flex-row  gap-4 justify-center md:justify-start mx-12 md:mx-0">
                        <button
                            className="main-button outline-none focus:outline-none start-trial-btn hover:no-underline hover:shadow-lg transition duration-300 ease-in-out inline-flex items-center justify-center md:justify-start gap-1"
                            onClick={handleButtonClick}
                        >
                            {buttonText}
                        </button>
                    </div>

                    {!noSection && (
                        <div className="flex gap-4 px-2 lg:px-0 mt-6">
                            {["No setup fee", "No credit card required"].map((each) => {
                                return (
                                    <div className="flex items-center gap-1 md:gap-2" key={each}>
                                        <img src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg" alt="Gray checkmark" className="opacity-50" />
                                        <p className="head-points text-gray-400">{each}</p>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
                <div className="lg:w-1/2 w-full">
                    <Image width={560} height={420} loading="lazy" src={imageUrl} alt="header-image" />
                </div>
            </div>
        </header>
    );
};

export default GenerateLinksHeader;
